import type { NoticeGroup } from './api/employeeNotificationsApi';

export const employeeNotificationKeys = {
  all: ['employee-notifications'] as const,
  mine: (employeeId: number, group?: NoticeGroup) =>
    [...employeeNotificationKeys.all, 'mine', employeeId, group ?? 'all'] as const,
};
